// src/components/layout/Layout.jsx
import React, { useState } from 'react';
import { 
  Monitor,
  Bell,
  User,
  ChevronDown,
  Wifi,
  Settings
} from 'lucide-react';
import Navigation from './Navigation';

// Header avec navigation fonctionnelle
const Header = () => {
  return (
    <header className="layout-header">
      <div className="px-6 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
              <Monitor className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">ÉcranFacile Pro</h1>
              <p className="text-sm text-gray-600">La Grange des Pains</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm">
              <div className="flex items-center space-x-1">
                <Wifi className="h-4 w-4 text-green-600" />
                <span className="text-gray-600">2/3 en ligne</span>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <button className="relative p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-lg hover:bg-gray-100">
                <Bell className="h-5 w-5" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
              </button>
              
              <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-lg hover:bg-gray-100">
                <Settings className="h-5 w-5" />
              </button>
              
              <div className="flex items-center space-x-2 p-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                  <User className="h-4 w-4 text-white" />
                </div>
                <div className="hidden md:block text-left">
                  <div className="text-sm font-medium text-gray-700">Admin</div>
                  <div className="text-xs text-gray-500">Gestionnaire</div>
                </div>
                <ChevronDown className="h-4 w-4 text-gray-400" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const Layout = ({ children }) => {
  return (
    <div className="layout-container">
      <Header />
      <Navigation />
      <main className="layout-main">
        {children}
      </main>
    </div>
  );
};

export default Layout;